module.exports = __webpack_public_path__ + "img/logo.060a7be5.png";